<div class="card card-custom gutter-b card-strech">
    <div class="card-header card-header-tabs-line">
        <div class="card-toolbar">
            <ul class="nav nav-tabs nav-bold nav-tabs-line">
                 
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{ 'active': vital }" id="pills-vital-tab" data-toggle="tab"
                        data-bs-target="#pills-vital" href="#pills-vital" (click)="ver('vital')">
                        Vital Signs
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{ 'active': dental }" id="pills-dental-tab" data-toggle="tab"
                        data-bs-target="#pills-dental" href="#pills-dental" (click)="ver('dental')">
                        Dental
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{ 'active': proc }" id="pills-proc-tab" data-toggle="tab"
                        data-bs-target="#pills-dental" href="#pills-proc" (click)="ver('proc')">
                        Procedures
                    </a>
                </li>
              
            </ul>
        </div>
    </div>
    <div class="tab-content">
         
        <div class="tab-pane fade" [ngClass]="{ 'show active': vital }" id="pills-vital" role="tabpanel"
            aria-labelledby="pills-vital-tab">
            <ngx-work-profile-vital [pet_no]="pet_no"></ngx-work-profile-vital>
        </div>
        <div class="tab-pane fade" [ngClass]="{ 'show active': dental }" id="pills-dental" role="tabpanel"
            aria-labelledby="pills-dental-tab">
            <ngx-work-profile-dental [pet_no]="pet_no"></ngx-work-profile-dental>
        </div>
        <div class="tab-pane fade" [ngClass]="{ 'show active': proc }" id="pills-proc" role="tabpanel"
            aria-labelledby="pills-proc-tab">
            <ngx-profile-proc [pet_no]="pet_no"></ngx-profile-proc>
        </div>
       
    </div>
</div>